export default class NightFlexVariantError extends Error
{
    /** @type {string} The NightFlex variant, a.k.a. model. */
    variant = '';

    constructor(message, variant)
    {
        super(message);
        this.name = this.constructor.name;
        this.variant = variant;
    }
};
